import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import InfoIcon from '~/icons/srp/InfoIcon';

export default function CkPromoLineItem() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { setCreditKarmaPromoModalOpen } = useContext(ModalContext);

  const handleTooltipClick = () => {
    trackEvent('Clicked - SPT Price Details - Credit Karma promo tooltip');
    setCreditKarmaPromoModalOpen(true);
  };

  return (
    <span className="flex items-center gap-4">
      Credit Karma savings{' '}
      <Clickable
        data-analytics-id={null}
        element={InfoIcon}
        fill="var(--cvna-color-blue-6)"
        onClick={handleTooltipClick}
      />
    </span>
  );
}
